export function getYouTubeSearchErrorMessage(error) {
  if (error.response?.status === 429) {
    const retryAfter = Number(error.response.headers?.['retry-after'])
    const retryMessage = Number.isFinite(retryAfter) && retryAfter > 0
      ? `Try again in ${Math.ceil(retryAfter)} seconds.`
      : 'Please wait a moment and try again.'
    return `Too many requests to this app. ${retryMessage}`
  }

  const detail = error.response?.data?.detail || error.message || 'Failed to search YouTube'
  return `YouTube Search Error: ${detail}`
}
